// Wisdom Capsules — library of resources.
// Each capsule item has a `type` (html | youtube | facebook | audio | video | external | pdf)
// and a `url` that opens in a new tab when clicked, preserving the original asset as-is.
//
// To add a new capsule: just push a new item to `topics` under a chapter,
// or add a new chapter entirely. No UI changes required.

export const wisdomCapsules = [
  {
    number: 1,
    title: "The Complete Vedic Flow of Manifestation",
    topics: [
      {
        number: "1.1",
        title: "From Goloka to Karma-Phala",
        type: "html",
        url: "/wisdom-capsules/vedic-complete-flow.html",
      },
      {
        number: "1.2",
        title: "The Jīva's Journey — From Bondage to Divinity",
        type: "html",
        url: "/wisdom-capsules/jivas-journey.html",
      },
      // Examples for future items (add as needed):
      // { number: "1.2", title: "Talk · Bhagavad Gita Ch. 2", type: "youtube", url: "https://youtu.be/..." },
      // { number: "1.3", title: "Podcast · Silence as Practice", type: "audio",  url: "https://..." },
      // { number: "1.4", title: "Reflection · Vasana & Karma",  type: "pdf",    url: "/wisdom-capsules/vasana.pdf" },
      // { number: "1.5", title: "Live Sat-Sangha (Facebook)",   type: "facebook", url: "https://facebook.com/..." },
    ],
  },
];
